var _rect, _rect2, _rect3, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _rect4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCourses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 35.334,
    y: 12.167,
    width: 7.91667,
    height: 31.6667,
    rx: 0.5,
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13.167,
    y: 28,
    width: 7.91667,
    height: 15.8333,
    rx: 0.5,
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 24.25,
    y: 20.084,
    width: 7.91667,
    height: 23.75,
    rx: 0.5,
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 24.75,
    y1: 25.917,
    x2: 31.6667,
    y2: 25.917,
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 13.667,
    y1: 30.667,
    x2: 20.5837,
    y2: 30.667,
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 35.834,
    y1: 14.834,
    x2: 42.7507,
    y2: 14.834,
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 35.834,
    y1: 40.167,
    x2: 42.7507,
    y2: 40.167,
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 24.75,
    y1: 27.5,
    x2: 31.6667,
    y2: 27.5,
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 13.667,
    y1: 41.75,
    x2: 20.5837,
    y2: 41.75,
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 35.834,
    y1: 16.417,
    x2: 42.7507,
    y2: 16.417,
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 35.834,
    y1: 41.75,
    x2: 42.7507,
    y2: 41.75,
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 24.75,
    y1: 22.75,
    x2: 31.6667,
    y2: 22.75,
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 25.834,
    y: 39.084,
    width: 4.75,
    height: 3.16667,
    rx: 0.1,
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourses);
export default __webpack_public_path__ + "static/media/courses.73b5abc49ff277b0dc314bf3c5188fe2.svg";
export { ForwardRef as ReactComponent };